import { NavLink } from "react-router-dom";

function AboutSidebar() {
  const menuItems = [
    {
      title: "Chairman’s Message",
      path: "/chairman-message",
    },
    {
      title: "Principal’s Message",
      path: "/principal-message",
    },
    {
      title: "Know Us",
      path: "/know-us",
    },
    {
      title: "Our Journey",
      path: "/our-journey",
    },
  ];

  return (
    <div className="about-sidebar">
      {menuItems.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          className={({ isActive }) =>
            isActive ? "about-menu-btn active" : "about-menu-btn"
          }
        >
          {item.title}
        </NavLink>
      ))}
    </div>
  );
}

export default AboutSidebar;
